import _objectWithoutProperties from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from "react";
import { Field } from "redux-form"; // import { Field } from "react-final-form";

import SmartDropdown from "./SmartDropdown";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
var styles = {
  smart_dp_required: {// "padding-top": "2px",
    // marginTop: 6,
  },
  inputSelectMaterial: {
    marginTop: 6
  },
  smart_label: {
    fontSize: 12,
    width: '100%'
  },
  errorMessage: {
    color: "red",
    fontSize: "12px"
  }
};

var InputSelect =
/*#__PURE__*/
function (_Component) {
  _inherits(InputSelect, _Component);

  function InputSelect(props) {
    var _this;

    _classCallCheck(this, InputSelect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputSelect).call(this, props));
    _this.state = {
      value: props.value
    };
    return _this;
  }

  _createClass(InputSelect, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.editStatus) {
        if (this.props.validation.length > 0 && this.props.collapsible) {
          this.props.toggleSection(true);
        }
      }
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      return this.props.options.map(function (opt, i) {
        return React.createElement(MenuItem, {
          key: i,
          value: opt.value
        }, opt.text);
      });
    }
  }, {
    key: "handleChangeRequirement",
    value: function handleChangeRequirement(dataElementName, event, newValue, previousValue, name) {
      var dataElem = this.props.dataElementId;
      if (this.props.changeRequirement) this.props.changeRequirement(dataElem === undefined ? dataElementName : dataElem, event, newValue, previousValue, name);
    }
  }, {
    key: "handleBlurRequirement",
    value: function handleBlurRequirement(dataElementName, event, newValue, previousValue, name) {
      this.handleChangeRequirement(dataElementName, event, newValue, previousValue, name);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          context = _this$props.context;

      var renderSelectField = function renderSelectField(_ref) {
        var input = _ref.input,
            label = _ref.label,
            _ref$meta = _ref.meta,
            touched = _ref$meta.touched,
            error = _ref$meta.error,
            warning = _ref$meta.warning,
            children = _ref.children,
            custom = _objectWithoutProperties(_ref, ["input", "label", "meta", "children"]);

        var currentValue = input && input.value ? input.value : _this2.props.value;

        var optionMatch = _this2.props.options.find(function (option) {
          return option.value === currentValue;
        });

        var optionValue = {
          value: optionMatch ? optionMatch.value : currentValue,
          label: optionMatch ? optionMatch.text : currentValue
        };
        return React.createElement("div", {
          className: classes.inputSelectMaterial
        }, !_this2.props.isSmart ? React.createElement(FormControl, {
          fullWidth: true
        }, React.createElement(InputLabel, {
          htmlFor: "{this.props.name}"
        }, _this2.props.dataElementName), React.createElement(Select, Object.assign({
          className: _this2.props.className + (touched && error ? " errorText" : "")
        }, input, custom, {
          disabled: _this2.props.disabled,
          value: input && input.value ? input.value : _this2.props.value
        }), children)) : React.createElement("div", {
          className: classes.smart_dp_required
        }, React.createElement(SmartDropdown, Object.assign({
          hide: _this2.props.disabled,
          options: _this2.props.options,
          placeholder: "Select ".concat(_this2.props.name),
          validate: error && (touched || warning)
        }, input, {
          name: _this2.props.name
        }, custom, {
          id: "sel-" + input.name,
          optionValue: optionValue
        }))), touched && (error && React.createElement("span", {
          style: _this2.props.disabled ? {
            display: "none"
          } : {
            display: "inline"
          },
          className: classes.errorMessage
        }, error) || warning && React.createElement("span", {
          style: _this2.props.disabled ? {
            display: "none"
          } : {
            display: "inline"
          },
          className: "errorText"
        }, warning)));
      };

      return React.createElement("div", {
        style: {
          textOverflow: "ellipsis",
          overflow: "hidden"
        }
      }, React.createElement(Field, {
        id: this.props.id,
        name: this.props.fieldName ? this.props.fieldName : this.props.name,
        component: renderSelectField,
        context: context,
        validate: this.props.validation,
        onChange: function onChange(event, newValue, previousValue, name) {
          _this2.handleChangeRequirement(_this2.props.dataElementName, event, newValue, previousValue, name);
        },
        onBlur: function onBlur(event, newValue, previousValue, name) {
          _this2.handleBlurRequirement(_this2.props.dataElementName, event, newValue, previousValue, name);
        }
      }, this.renderOptions()));
    }
  }]);

  return InputSelect;
}(Component);

InputSelect.defaultProps = {
  disabled: true,
  name: null,
  value: "",
  className: null,
  options: [{
    value: "",
    text: "None"
  }]
};
export default withStyles(styles)(InputSelect);